<list-view [liste]="geographieService.listeDepartements" *ngIf="geographieService.listeDepartements"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>